/* global axios */
// API da área Nexus IA (custom/app/controllers/api/v1/accounts/neuxs). Só
// administrador da empresa; cada aba depende do seu recurso (SGP, WhatsApp).

export const createNexusApi = accountId => {
  const url = path => `/api/v1/accounts/${accountId}/neuxs${path}`;
  return {
    recursos: () => axios.get(url('/recursos')),
    manutencao: estado =>
      axios.get(url('/manutencao'), { params: estado ? { estado } : {} }),
    salvaMensagem: mensagem =>
      axios.put(url('/manutencao/mensagem'), { mensagem }),
    enviaAvisos: ids =>
      axios.post(url('/manutencao/enviar'), ids ? { ids } : {}),
    removeAvisos: ids => axios.post(url('/manutencao/remover'), { ids }),
    gateway: () => axios.get(url('/gateway')),
    geraGateway: dados => axios.post(url('/gateway'), dados),
    revogaGateway: sgpId =>
      axios.post(url('/gateway/revogar'), { sgp_id: sgpId }),
    criaModelo: dados => axios.post(url('/modelos'), dados),
    atualizaModelo: (id, dados) => axios.patch(url(`/modelos/${id}`), dados),
    alternaEnvio: id => axios.post(url(`/modelos/${id}/alternar_envio`)),
    apagaModelo: id => axios.delete(url(`/modelos/${id}`)),
    disparos: filtro => axios.get(url('/disparos'), { params: filtro }),
    whatsapp: () => axios.get(url('/whatsapp')),
    usoWhatsapp: filtro => axios.get(url('/whatsapp_uso'), { params: filtro }),
    whatsappCaixa: id => axios.get(url(`/whatsapp/${id}`)),
    criaWhatsapp: dados => axios.post(url('/whatsapp'), dados),
    conectaWhatsapp: id => axios.post(url(`/whatsapp/${id}/conectar`)),
    roteamentoWhatsapp: (id, dados) =>
      axios.patch(url(`/whatsapp/${id}`), dados),
    codigoWhatsapp: id => axios.post(url(`/whatsapp/${id}/codigo`)),
    reconectaWhatsapp: id => axios.post(url(`/whatsapp/${id}/reconectar`)),
    desconectaWhatsapp: id => axios.post(url(`/whatsapp/${id}/desconectar`)),
    teia: () => axios.get(url('/teia')),
    numerosDaTeia: () => axios.get(url('/teia/numeros')),
    eventosDaTeia: depois =>
      axios.get(url('/teia/eventos'), { params: { depois } }),
  };
};

export const erroDaApi = (error, padrao) =>
  error?.response?.data?.erro || padrao;
